import Image from '../../components/Image/Image';
import useCart from '../Cart/useCart';
import useStyles from './styles';

function StoreLogo() {
  const classes = useStyles();
  const { storeLogo, storeName } = useCart();

  return <Image src={storeLogo} alt={storeName} className={classes.logo} />;
}

export default StoreLogo;
